{
  "schemaVersion": "1.3.0",
  "status": "reference-only-persisted-with-publisher-fallbacks",
  "candidateCount": 29,
  "recordCount": 28,
  "unavailableCount": 3,
  "trainingEligibleCount": 0,
  "originRegistryCount": 3,
  "policy": "These binaries are rights-cleared reference evidence only. Optional publisher outages are recorded and do not erase previously verified local copies. Persistence never makes a full figure or composite model-training eligible.",
  "records": [
    {
      "id": "bugwood-broad-mite-5077061",
      "issue_slug": "broad-mite",
      "repository_path": "images/reference/original/bugwood-broad-mite-5077061.jpg",
      "source_image_url": "https://commons.wikimedia.org/wiki/Special:Redirect/file/Broadmite.jpg",
      "resolved_image_url": "https://upload.wikimedia.org/wikipedia/commons/b/b2/Broadmite.jpg?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=original",
      "source_article": "https://commons.wikimedia.org/wiki/File:Broadmite.jpg",
      "caption": "Broad-mite morphology reference credited through Bugwood; no host plant is shown, so this is not cannabis symptom ground truth.",
      "creator": "David B. Langston, University of Georgia, Bugwood.org",
      "license": "CC BY 3.0 US",
      "license_url": "https://creativecommons.org/licenses/by/3.0/us/",
      "required_attribution": "David B. Langston, University of Georgia, Bugwood.org; CC BY 3.0 US; link the license and indicate modifications.",
      "confirmation": "expert-reviewed",
      "limitations": [
        "No host or symptom context.",
        "Dark appearance may reflect imaging conditions and is not a reliable field-color feature.",
        "Reference-only pending a separate training and dataset-split review."
      ],
      "diagnostic_label": "broad-mite-adult-microscope-morphology",
      "host_species": "No host shown; isolated mite specimen",
      "host_context": "organism-only",
      "view": "microscope",
      "stage": "adult",
      "severity": "confirmed organism",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "e164d39934d1f88fd7220771d0458dfab908720b14b498871c31a2a4400c0fa8",
      "perceptual_hash": "dhash64:0313253333192713",
      "bytes": 631259,
      "mime_type": "image/jpeg",
      "width": 1534,
      "height": 1034,
      "image_format": "JPEG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "frontiers-cannabis-ammonium-toxicity-figure-2",
      "issue_slug": "nitrogen-toxicity",
      "repository_path": "images/reference/original/frontiers-cannabis-ammonium-toxicity-figure-2.jpg",
      "source_image_url": "https://www.frontiersin.org/files/Articles/830224/fpls-13-830224-HTML/image_m/fpls-13-830224-g002.jpg",
      "resolved_image_url": "https://www.frontiersin.org/files/Articles/830224/fpls-13-830224-HTML/image_m/fpls-13-830224-g002.jpg",
      "source_article": "https://doi.org/10.3389/fpls.2022.830224",
      "caption": "Controlled early severe ammonium-form injury at the growing tip, photographed 17 days after initiation of the 100% ammonium and 0% nitrate treatment.",
      "creator": "Avia Saloner and Nirit Bernstein",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": "Saloner A and Bernstein N (2022), Frontiers in Plant Science 13:830224, Figure 2, CC BY 4.0; credit the authors, link the source and license, and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "The image represents an extreme 100% ammonium and 0% nitrate treatment at fixed 200 mg/L total nitrogen, not generic excess total nitrogen.",
        "The authors cautioned that reduced or absent nitrate may contribute to injury, so the image cannot establish a single unconfounded mechanism.",
        "One cultivar, five replicates, reproductive-stage controlled conditions, and one formulation do not establish universal symptoms or timing.",
        "Reference display only until the image and any derivatives are scientifically reviewed, source-grouped, and assigned a leakage-safe split with extreme-treatment metadata."
      ],
      "diagnostic_label": "nitrogen-toxicity-cannabis-severe-ammonium-form-apical-day-17",
      "host_species": "Cannabis sativa medical cultivar",
      "host_context": "cannabis",
      "view": "close-up",
      "stage": "reproductive day 17 after treatment initiation",
      "severity": "severe early ammonium-form injury",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "5ca9e552b4c14700d99fd528b1db2ec2c31b1f14d405f0cfc36f33d518f71e24",
      "perceptual_hash": "dhash64:8bb3b7e369cc89cd",
      "bytes": 452018,
      "mime_type": "image/jpeg",
      "width": 2217,
      "height": 2217,
      "image_format": "JPEG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "frontiers-cannabis-botrytis-figure-4",
      "issue_slug": "botrytis-gray-mold-bud-rot",
      "repository_path": "images/reference/original/frontiers-cannabis-botrytis-figure-4.webp",
      "source_image_url": "https://www.frontiersin.org/files/Articles/439316/xml-images/fpls-10-01120-g004.webp",
      "resolved_image_url": "https://www.frontiersin.org/files/Articles/439316/xml-images/fpls-10-01120-g004.webp",
      "source_article": "https://doi.org/10.3389/fpls.2019.01120",
      "caption": "Cannabis-specific scientific composite: panels include developing and destroyed inflorescences, internal harvested-flower decay, culture and microscopy views, and late-harvest leaf lesions. Use panel-level context; the composite is not one homogeneous image class.",
      "creator": "Zamir K. Punja, Danielle Collyer, Cameron Scott, Samantha Lung, Janesse Holmes, and Darren Sutton",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": "Punja ZK, Collyer D, Scott C, Lung S, Holmes J, Sutton D (2019), Frontiers in Plant Science 10:1120, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "Scientific reference only until each panel is separately bounded, annotated, and assigned a dataset split.",
        "Panels A-D and H-I show plant phenotypes; panels E-G show culture or microscope morphology and must not be mixed into a symptom-image class.",
        "Brown flower decay overlaps Fusarium and Penicillium; the figure cannot establish that appearance alone is species-specific."
      ],
      "diagnostic_label": "botrytis-gray-mold-bud-rot-cannabis-multi-panel-progression",
      "host_species": "Cannabis sativa",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "flower through postharvest; culture and microscopy panels included",
      "severity": "early through advanced",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "4ed61bf021a048297bbb06cc9125f331fa2158d8e30159f20c8ef52091a9dda6",
      "perceptual_hash": "dhash64:5595d3d149492567",
      "bytes": 2141232,
      "mime_type": "image/webp",
      "width": 1175,
      "height": 1720,
      "image_format": "WEBP",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "frontiers-cannabis-nitrogen-dose-figure-1",
      "issue_slug": "nitrogen-toxicity",
      "repository_path": "images/reference/original/frontiers-cannabis-nitrogen-dose-figure-1.jpg",
      "source_image_url": "https://www.frontiersin.org/files/Articles/572293/fpls-11-572293-HTML/image_m/fpls-11-572293-g001.jpg",
      "resolved_image_url": "https://www.frontiersin.org/files/Articles/572293/fpls-11-572293-HTML/image_m/fpls-11-572293-g001.jpg",
      "source_article": "https://doi.org/10.3389/fpls.2020.572293",
      "caption": "Controlled vegetative dose response. Columns show 30, 80, 160, 240, and 320 mg/L total nitrogen; rows show whole plants, youngest fully developed leaves, and roots. The 320 mg/L treatment was smaller and dark green, while root restriction was already evident at 240 mg/L.",
      "creator": "Avia Saloner and Nirit Bernstein",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": "Saloner A and Bernstein N (2020), Frontiers in Plant Science 11:572293, Figure 1, CC BY 4.0; credit the authors, link the source and license, and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "Five columns are distinct nitrogen doses and three rows are distinct organs or views; whole-image single-class labeling and random panel splitting are invalid.",
        "Only the 320 mg/L column was described as visually overdosed; 240 mg/L showed restricted roots while shoot coloration and development remained similar to the 160 mg/L treatment.",
        "One cultivar, long photoperiod, soilless media, treatment-specific EC, and one formulation do not establish universal visual or analytical thresholds.",
        "Reference display only until panels are bounded, dose-, organ-, time-, and diagnosis-annotated, scientifically reviewed, source-grouped, and assigned a leakage-safe split."
      ],
      "diagnostic_label": "nitrogen-toxicity-cannabis-total-dose-response-controlled-mixed-dose-and-organ",
      "host_species": "Cannabis sativa medical cultivar",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "vegetative day 31 dose response",
      "severity": "deficient through excessive dose context",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "1846c08b0267f81750436126bc985d3b5174ea059bc47bd03080794586b2c163",
      "perceptual_hash": "dhash64:f555d55555555571",
      "bytes": 338213,
      "mime_type": "image/jpeg",
      "width": 2209,
      "height": 1622,
      "image_format": "JPEG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "mdpi-cannabis-calcium-deficiency-figure-5",
      "issue_slug": "calcium-deficiency",
      "repository_path": "images/reference/original/mdpi-cannabis-calcium-deficiency-figure-5.png",
      "source_image_url": "https://www.mdpi.com/plants/plants-12-00422/article_deploy/html/images/plants-12-00422-g005.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/plants/plants-12-00422/article_deploy/html/images/plants-12-00422-g005.png",
      "source_article": "https://doi.org/10.3390/plants12030422",
      "caption": "Controlled flowering-stage calcium-withholding sequence: lower-fan-leaf yellow-ringed necrotic spots progress toward marginal necrosis, then upper fan and sugar leaves become affected and upper tips curl upward.",
      "creator": "David Llewellyn, Scott Golem, A. Maxwell P. Jones, and Youbin Zheng",
      "license": "CC BY 4.0",
      "required_attribution": "Llewellyn D, Golem S, Jones AMP, Zheng Y (2023), Plants 12(3):422, Figure 5, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "One cultivar, three plants per treatment, flowering-stage deep-water culture, and complete calcium withholding do not establish universal field symptoms or timing.",
        "The five panels are a temporal sequence from the same experimental treatment; preserve panel order and source grouping and do not split panels across train and evaluation sets.",
        "Reference display only until each panel is bounded, stage-annotated, scientifically reviewed, and assigned a leakage-safe dataset split."
      ],
      "diagnostic_label": "calcium-deficiency-cannabis-flowering-controlled-progression",
      "host_species": "Cannabis sativa Gelato 29",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "flowering weeks three through six",
      "severity": "initial through advanced",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "b86b46145ee789dc843fe046d26ea92dac669d29acccb932bfbcc2ea10441530",
      "perceptual_hash": "dhash64:cc8ccdececccc6c4",
      "bytes": 5718917,
      "mime_type": "image/png",
      "width": 2108,
      "height": 3577,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "official-publisher-alternate-render-visual-match",
      "verification_status": "publisher-fallback-validated-hashed-and-persisted",
      "expected_sha256": "496a84d54a30f85621b66481472d75e0fbf12b072aae8add8d19eede0cedcf9e",
      "expected_perceptual_hash": "dhash64:cc8ccdedecccc6c4",
      "dhash_distance_from_curated": 1
    },
    {
      "id": "mdpi-cannabis-iron-zinc-deficiency-figure-6",
      "issue_slug": "iron-deficiency",
      "repository_path": "images/reference/original/mdpi-cannabis-iron-zinc-deficiency-figure-6.png",
      "source_image_url": "https://www.mdpi.com/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g006.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g006.png",
      "source_article": "https://doi.org/10.3390/app9204432",
      "caption": "Controlled vegetative composite. The left column documents iron withholding from initial marginal paling through upper/new-leaf interveinal chlorosis; the right column is a separate zinc-deficiency class and must not be labeled as iron.",
      "creator": "Paul Cockson, Hunter Landis, Turner Smith, Kristin Hicks, and Brian E. Whipker",
      "license": "CC BY 4.0",
      "required_attribution": "Cockson P, Landis H, Smith T, Hicks K, Whipker BE (2019), Applied Sciences 9(20):4432, Figure 6, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "One cultivar, silica-sand culture, complete iron withholding, and the nine-week onset do not establish universal field symptoms or timing.",
        "The composite contains two diagnosis classes: only the left column is iron deficiency, while the right column is zinc deficiency; whole-image class labels are invalid.",
        "The three rows are a severity sequence from the same experiment; preserve source grouping and do not split related panels across train and evaluation sets.",
        "Reference display only until every panel is bounded, class- and stage-annotated, independently reviewed, and assigned a leakage-safe dataset split."
      ],
      "diagnostic_label": "iron-deficiency-cannabis-controlled-progression-mixed-with-zinc",
      "host_species": "Cannabis sativa T1",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "vegetative initial through advanced",
      "severity": "initial through advanced",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "8d3992c7a40cfd3c677f0b6271e7f598e3fc177aa8ebc53783d971e252954782",
      "perceptual_hash": "dhash64:a8b8e885b4ce99a1",
      "bytes": 478425,
      "mime_type": "image/png",
      "width": 2241,
      "height": 2079,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "official-publisher-alternate-render-visual-match",
      "verification_status": "publisher-fallback-validated-hashed-and-persisted",
      "expected_sha256": "6cb7f6abc5935d6926871f6abf4550ceaacd89aa979fc9300c1976d1fe840d87",
      "expected_perceptual_hash": "dhash64:a8b8e8a5b4ce99a1",
      "dhash_distance_from_curated": 1
    },
    {
      "id": "mdpi-cannabis-magnesium-deficiency-figure-6",
      "issue_slug": "magnesium-deficiency",
      "repository_path": "images/reference/original/mdpi-cannabis-magnesium-deficiency-figure-6.png",
      "source_image_url": "https://www.mdpi.com/plants/plants-12-00422/article_deploy/html/images/plants-12-00422-g006.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/plants/plants-12-00422/article_deploy/html/images/plants-12-00422-g006.png",
      "source_article": "https://doi.org/10.3390/plants12030422",
      "caption": "Controlled flowering Gelato 29 progression from mild week-four lower-fan-leaf interveinal chlorosis through rapid smaller-fan-leaf involvement, interveinal necrosis, and widespread week-six yellowing with relatively spared apical inflorescences.",
      "creator": "David Llewellyn, Scott Golem, A. Maxwell P. Jones, and Youbin Zheng",
      "license": "CC BY 4.0",
      "required_attribution": "Llewellyn D, Golem S, Jones AMP, Zheng Y (2023), Plants 12(3):422, Figure 6, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "One cultivar, three plants per treatment, flowering-stage deep-water culture, and complete magnesium withholding do not establish universal production symptoms, timing, yield effects, or tissue thresholds.",
        "The five panels mix close-up, whole-plant, detached-leaf, and inflorescence-context views across several weeks and severity states; every panel needs separate view, tissue, stage, and severity annotation.",
        "Preserve source grouping across all panels and derivatives and do not split related observations across training and evaluation.",
        "Reference display only until panels are bounded, individually annotated, scientifically reviewed, and assigned a leakage-safe dataset split."
      ],
      "diagnostic_label": "magnesium-deficiency-cannabis-flowering-controlled-progression",
      "host_species": "Cannabis sativa Gelato 29",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "week four through week six flowering deficiency",
      "severity": "initial through advanced",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "e1ed2338bf94481707197103055bde83e6aec151714d0cd44c975213c7c9c97f",
      "perceptual_hash": "dhash64:c486c6aa6ae4c4ce",
      "bytes": 6835502,
      "mime_type": "image/png",
      "width": 2549,
      "height": 4150,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "official-publisher-alternate-render-visual-match",
      "verification_status": "publisher-fallback-validated-hashed-and-persisted",
      "expected_sha256": "3fbec5e7662c1efb634550afabef95f2eb4b847f7ddfe254db99c678c624fc94",
      "expected_perceptual_hash": "dhash64:c486c6aa2ae4c4ce",
      "dhash_distance_from_curated": 1
    },
    {
      "id": "mdpi-cannabis-mn-b-cu-deficiency-figure-4",
      "issue_slug": "manganese-deficiency",
      "repository_path": "images/reference/original/mdpi-cannabis-mn-b-cu-deficiency-figure-4.png",
      "source_image_url": "https://www.mdpi.com/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g004.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g004.png",
      "source_article": "https://doi.org/10.3390/app9204432",
      "caption": "Controlled vegetative composite. The left column documents manganese-deficiency progression from bright netted upper/central interveinal chlorosis to tan necrotic flecks; the middle and right columns are separate boron- and copper-deficiency classes.",
      "creator": "Paul Cockson, Hunter Landis, Turner Smith, Kristin Hicks, and Brian E. Whipker",
      "license": "CC BY 4.0",
      "required_attribution": "Cockson P, Landis H, Smith T, Hicks K, Whipker BE (2019), Applied Sciences 9(20):4432, Figure 4, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "One cultivar, silica-sand culture, complete manganese withholding, and the six-week onset do not establish universal field symptoms, timing, or tissue thresholds.",
        "The composite contains three diagnosis classes: only the left column is manganese deficiency; the middle is boron deficiency and the right is copper deficiency, so a whole-image single-class label is invalid.",
        "The rows are a severity sequence from one experiment; preserve source grouping and do not split related panels across training and evaluation.",
        "Reference display only until every panel is bounded, class- and stage-annotated, independently reviewed, and assigned a leakage-safe dataset split."
      ],
      "diagnostic_label": "manganese-deficiency-cannabis-controlled-progression-mixed-with-boron-and-copper",
      "host_species": "Cannabis sativa T1",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "initial, intermediate, and advanced vegetative deficiency",
      "severity": "initial through advanced",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "aea0f6b7d005a207352eb93fad0c0916b731b4f173e60cbb997ee4bffdb85e2e",
      "perceptual_hash": "dhash64:96a99db4ac9dadb4",
      "bytes": 617410,
      "mime_type": "image/png",
      "width": 2598,
      "height": 1599,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "official-publisher-alternate-render-visual-match",
      "verification_status": "publisher-fallback-validated-hashed-and-persisted",
      "expected_sha256": "d564930612a16469a967ff1d200a042f62685bb22425ae5bc3e73dda5ef22956",
      "expected_perceptual_hash": "dhash64:96b99db4bd9dadb4",
      "dhash_distance_from_curated": 3
    },
    {
      "id": "mdpi-cannabis-mn-b-toxicity-figure-5",
      "issue_slug": "boron-toxicity",
      "repository_path": "images/reference/original/mdpi-cannabis-mn-b-toxicity-figure-5.png",
      "source_image_url": "https://www.mdpi.com/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g005.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g005.png",
      "source_article": "https://doi.org/10.3390/app9204432",
      "caption": "Controlled-study composite. The right column shows boron-toxicity progression from marginal yellowing to inward-spreading chlorosis and advanced brown necrosis; the left manganese column is a separate diagnosis.",
      "creator": "Paul Cockson, Hunter Landis, Turner Smith, Kristin Hicks, and Brian E. Whipker",
      "license": "CC BY 4.0",
      "required_attribution": "Cockson P, Landis H, Smith T, Hicks K, Whipker BE (2019), Applied Sciences 9(20):4432, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "Scientific reference only until the right-side boron panels are separately cropped, bounded, and assigned a dataset split.",
        "The composite contains two diagnosis classes: manganese toxicity in the left column and boron toxicity in the right; do not train or infer one label from the full image.",
        "One cultivar and tenfold-supply protocol do not establish universal symptom timing, tissue thresholds, or production-system response."
      ],
      "diagnostic_label": "boron-toxicity-cannabis-controlled-progression-composite",
      "host_species": "Cannabis sativa T1",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "initial, intermediate, and advanced vegetative toxicity",
      "severity": "initial through advanced",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "38b74c1a4e69f79d943fafebe8fa5bb0146b52eb42b17cf49f7fafe460d6155c",
      "perceptual_hash": "dhash64:c6b3a99292cab9bc",
      "bytes": 435680,
      "mime_type": "image/png",
      "width": 2079,
      "height": 1866,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "official-publisher-alternate-render-visual-match",
      "verification_status": "publisher-fallback-validated-hashed-and-persisted",
      "expected_sha256": "a5ea13b2d3cbf9e54a74c14cada967951295f773ae78682a6be5537022441ce3",
      "expected_perceptual_hash": "dhash64:c6b3a99292cab9bc",
      "dhash_distance_from_curated": 0
    },
    {
      "id": "mdpi-cannabis-n-p-ca-deficiency-figure-2",
      "issue_slug": "phosphorus-deficiency",
      "repository_path": "images/reference/original/mdpi-cannabis-n-p-ca-deficiency-figure-2.png",
      "source_image_url": "https://www.mdpi.com/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g002.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g002.png",
      "source_article": "https://doi.org/10.3390/app9204432",
      "caption": "Controlled-study composite. The center column shows phosphorus-withheld Cannabis sativa T1 progressing from lower-leaf olive spotting to enlarged sunken-looking spots with marginal necrosis and then extensive olive and necrotic areas. Nitrogen and calcium columns are separate classes.",
      "creator": "Paul Cockson, Hunter Landis, Turner Smith, Kristin Hicks, and Brian E. Whipker",
      "license": "CC BY 4.0",
      "required_attribution": "Cockson P, Landis H, Smith T, Hicks K, Whipker BE (2019), Applied Sciences 9(20):4432, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "Scientific reference only until the center phosphorus panels are separately cropped, bounded, and assigned a dataset split.",
        "The composite contains three diagnosis classes: nitrogen in the left column, phosphorus in the center, and calcium in the right; do not train or infer one label from the full image.",
        "One cultivar and withholding protocol do not establish universal symptom timing, colors, tissue thresholds, or production-system response."
      ],
      "diagnostic_label": "phosphorus-deficiency-cannabis-controlled-progression-composite",
      "host_species": "Cannabis sativa T1",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "initial, intermediate, and advanced vegetative deficiency",
      "severity": "initial through advanced",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "156eb9701ea730b3e6d2de517dda5120a39eba3c2f7e8b14404558ca8bae2b2e",
      "perceptual_hash": "dhash64:93b99ac9c4cdccd9",
      "bytes": 624705,
      "mime_type": "image/png",
      "width": 2718,
      "height": 1818,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "official-publisher-alternate-render-visual-match",
      "verification_status": "publisher-fallback-validated-hashed-and-persisted",
      "expected_sha256": "c9200d6cb4fc0ee7a31908b9df06240a86ec6f2cf53fb8bece5098e4ee422952",
      "expected_perceptual_hash": "dhash64:93b99ac9c4cdccd9",
      "dhash_distance_from_curated": 0
    },
    {
      "id": "mdpi-cannabis-nitrogen-deficiency-figure-2-flowering",
      "issue_slug": "nitrogen-deficiency",
      "repository_path": "images/reference/original/mdpi-cannabis-nitrogen-deficiency-figure-2-flowering.png",
      "source_image_url": "https://www.mdpi.com/plants/plants-12-00422/article_deploy/html/images/plants-12-00422-g002.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/plants/plants-12-00422/article_deploy/html/images/plants-12-00422-g002.png",
      "source_article": "https://doi.org/10.3390/plants12030422",
      "caption": "Controlled flowering Gelato 29 nitrogen-withholding composite. Panels document week-three lower fan-leaf onset, week-four leaf and canopy progression, and week-five fan-leaf senescence with stem and early sugar-leaf involvement.",
      "creator": "David Llewellyn, Scott Golem, A. Maxwell P. Jones, and Youbin Zheng",
      "license": "CC BY 4.0",
      "required_attribution": "Llewellyn D, Golem S, Jones AMP, Zheng Y (2023), Plants 12(3):422, Figure 2, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "One cultivar, three plants per treatment, flowering-stage deep-water culture, and complete nitrogen withholding do not establish universal production symptoms, timing, yield effects, or tissue thresholds.",
        "The four panels combine close-up, detached-leaf, canopy, stem, and inflorescence-context views from weeks three through five; every panel requires separate view, tissue, stage, and severity annotation.",
        "Late-flower senescence, magnesium or sulfur status, root-zone dysfunction, and lighting must remain active confounders for yellow foliage.",
        "Preserve source grouping across all panels and derivatives and do not split related observations across training and evaluation.",
        "Reference display only until panels are bounded, individually annotated, scientifically reviewed, and assigned a leakage-safe dataset split."
      ],
      "diagnostic_label": "nitrogen-deficiency-cannabis-flowering-controlled-progression",
      "host_species": "Cannabis sativa Gelato 29",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "flowering weeks three through five",
      "severity": "initial through advanced",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "b88e07ce93803d1b3725d6bf972d829b089263aca9e955ba078a2aa4f53da049",
      "perceptual_hash": "dhash64:a2821212d2cccccc",
      "bytes": 5831687,
      "mime_type": "image/png",
      "width": 2510,
      "height": 3508,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "official-publisher-alternate-render-visual-match",
      "verification_status": "publisher-fallback-validated-hashed-and-persisted",
      "expected_sha256": "8d83e7fff889ce76f88930e35c56e171390770291c35210a63d4d4622d0181e3",
      "expected_perceptual_hash": "dhash64:a2821212d2cccccc",
      "dhash_distance_from_curated": 0
    },
    {
      "id": "mdpi-cannabis-potassium-deficiency-figure-4",
      "issue_slug": "potassium-deficiency",
      "repository_path": "images/reference/original/mdpi-cannabis-potassium-deficiency-figure-4.png",
      "source_image_url": "https://www.mdpi.com/plants/plants-12-00422/article_deploy/html/images/plants-12-00422-g004.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/plants/plants-12-00422/article_deploy/html/images/plants-12-00422-g004.png",
      "source_article": "https://doi.org/10.3390/plants12030422",
      "caption": "Controlled flowering Gelato 29 sequence. Panels separate dark lesions around secondary sugar-leaf veins from lighter fan-leaf tip and marginal injury, then show both pathways together in the middle canopy during week five.",
      "creator": "David Llewellyn, Scott Golem, A. Maxwell P. Jones, and Youbin Zheng",
      "license": "CC BY 4.0",
      "required_attribution": "Llewellyn D, Golem S, Jones AMP, Zheng Y (2023), Plants 12(3):422, Figure 4, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "One cultivar, three plants per treatment, flowering-stage deep-water culture, and complete potassium withholding do not establish universal symptoms, onset times, yield effects, or tissue thresholds.",
        "The four panels combine sugar-leaf and fan-leaf close-ups with middle-canopy distribution views from weeks four and five; each panel requires separate tissue, view, week, and severity annotation.",
        "Dark sugar-leaf lesions are not potassium-specific and must remain linked to treatment, tissue analysis, and pathogen exclusions.",
        "Preserve source grouping across all panels and derivatives and do not split related observations across training and evaluation.",
        "Reference display only until panels are bounded, individually annotated, scientifically reviewed, and assigned a leakage-safe dataset split."
      ],
      "diagnostic_label": "potassium-deficiency-cannabis-flowering-leaf-type-progression",
      "host_species": "Cannabis sativa Gelato 29",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "week four through week five flowering deficiency",
      "severity": "initial through moderate",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "1354b10bba8d1ae5d2210f0ef525869a4ec8ae65563c8149b95706bffb9ae50c",
      "perceptual_hash": "dhash64:ccccc8d8f060f1f0",
      "bytes": 6373011,
      "mime_type": "image/png",
      "width": 1443,
      "height": 4008,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "official-publisher-alternate-render-visual-match",
      "verification_status": "publisher-fallback-validated-hashed-and-persisted",
      "expected_sha256": "8deee229aa5bcedb9e88eeb278c63f395ae34614f7ebdd3f256544bda2d1c15d",
      "expected_perceptual_hash": "dhash64:ccccc8d8f060f1f0",
      "dhash_distance_from_curated": 0
    },
    {
      "id": "mdpi-cannabis-s-mg-k-deficiency-figure-3",
      "issue_slug": "magnesium-deficiency",
      "repository_path": "images/reference/original/mdpi-cannabis-s-mg-k-deficiency-figure-3.png",
      "source_image_url": "https://www.mdpi.com/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g003.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g003.png",
      "source_article": "https://doi.org/10.3390/app9204432",
      "caption": "Controlled vegetative composite. The center column documents magnesium-deficiency progression from lower/older interveinal yellowing to strong green-vein contrast and necrosis; the left and right columns are separate sulfur- and potassium-deficiency classes.",
      "creator": "Paul Cockson, Hunter Landis, Turner Smith, Kristin Hicks, and Brian E. Whipker",
      "license": "CC BY 4.0",
      "required_attribution": "Cockson P, Landis H, Smith T, Hicks K, Whipker BE (2019), Applied Sciences 9(20):4432, Figure 3, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "One cultivar, silica-sand culture, complete magnesium withholding, and the seven-week onset do not establish universal field symptoms, timing, or tissue thresholds.",
        "The composite contains three diagnosis classes: only the center column is magnesium deficiency; the left is sulfur deficiency and the right is potassium deficiency, so a whole-image single-class label is invalid.",
        "The rows are a severity sequence from one experiment; preserve source grouping and do not split related panels across training and evaluation.",
        "Reference display only until every panel is bounded, class- and stage-annotated, independently reviewed, and assigned a leakage-safe dataset split."
      ],
      "diagnostic_label": "magnesium-deficiency-cannabis-controlled-progression-mixed-with-sulfur-and-potassium",
      "host_species": "Cannabis sativa T1",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "initial, intermediate, and advanced vegetative deficiency",
      "severity": "initial through advanced",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "f61e1206e1c7940ea609bfc9ead4afe0aff5cfd54ba51bc80a77c9113bbfe9ee",
      "perceptual_hash": "dhash64:908cb8edbdd2e9ad",
      "bytes": 790232,
      "mime_type": "image/png",
      "width": 2985,
      "height": 1893,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "exact-curated-byte-match",
      "verification_status": "previously-persisted-remote-temporarily-unavailable",
      "expected_sha256": "f61e1206e1c7940ea609bfc9ead4afe0aff5cfd54ba51bc80a77c9113bbfe9ee",
      "expected_perceptual_hash": "dhash64:9888b8ed9dd6e1ad",
      "dhash_distance_from_curated": 5
    },
    {
      "id": "mdpi-cannabis-sulfur-deficiency-figure-7",
      "issue_slug": "sulfur-deficiency",
      "repository_path": "images/reference/original/mdpi-cannabis-sulfur-deficiency-figure-7.png",
      "source_image_url": "https://www.mdpi.com/plants/plants-12-00422/article_deploy/html/images/plants-12-00422-g007.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/plants/plants-12-00422/article_deploy/html/images/plants-12-00422-g007.png",
      "source_article": "https://doi.org/10.3390/plants12030422",
      "caption": "Controlled flowering-stage sulfur-withholding composite: younger sugar leaves yellow first, upper fan leaves angle upward, fan-leaf interveinal chlorosis advances, and later injury is most severe on lower fan leaves.",
      "creator": "David Llewellyn, Scott Golem, A. Maxwell P. Jones, and Youbin Zheng",
      "license": "CC BY 4.0",
      "required_attribution": "Llewellyn D, Golem S, Jones AMP, Zheng Y (2023), Plants 12(3):422, Figure 7, CC BY 4.0; link the source and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "One cultivar, three plants per treatment, flowering-stage deep-water culture, and complete sulfur withholding do not establish universal field symptoms, timing, or yield effects.",
        "The four panels span sugar leaves, upper-canopy fan-leaf angle, a detached fan-leaf severity sequence, and whole-plant distribution; each requires its own view, tissue, stage, and severity annotation.",
        "Natural late-flower senescence and nitrogen deficiency can overlap the later yellowing, so source treatment and analytical linkage must remain attached to every derivative.",
        "Reference display only until panels are bounded, individually annotated, scientifically reviewed, source-grouped, and assigned a leakage-safe dataset split."
      ],
      "diagnostic_label": "sulfur-deficiency-cannabis-flowering-controlled-progression",
      "host_species": "Cannabis sativa Gelato 29",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "flowering weeks four onward",
      "severity": "initial through advanced",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "a468cfb8f8e734e3b336278568945ee483e742a5846075266185e822864ef252",
      "perceptual_hash": "dhash64:a6eeaba270e8f8b0",
      "bytes": 5216527,
      "mime_type": "image/png",
      "width": 1600,
      "height": 3981,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "official-publisher-alternate-render-visual-match",
      "verification_status": "publisher-fallback-validated-hashed-and-persisted",
      "expected_sha256": "a76a52d1b2742af256c769e784b6255413a176f4d4936ee07b7b0c4bc4af05a3",
      "expected_perceptual_hash": "dhash64:a6eeaba270e8f8b0",
      "dhash_distance_from_curated": 0
    },
    {
      "id": "media-bctv-cannabis-figure-19",
      "issue_slug": "beet-curly-top-virus",
      "repository_path": "images/reference/original/media-bctv-cannabis-figure-19.png",
      "source_image_url": "https://mdpi-res.com/d_attachment/ijms/ijms-25-00014/article_deploy/html/images/ijms-25-00014-g019.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/ijms/ijms-25-00014/article_deploy/html/images/ijms-25-00014-g019.png",
      "source_article": "https://doi.org/10.3390/ijms25010014",
      "caption": "Indoor- and outdoor-grown Cannabis plants with symptoms attributed to Beet curly top virus across multiple genotypes (Figure 19); BCTV presence was confirmed by RT-PCR with universal primers.",
      "creator": "Zamir K. Punja, Dieter Kahl, Ron Reade, Yu Xiang, Jack Munz, and Punya Nachappa; visualization credited to Zamir K. Punja",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": null,
      "confirmation": "Peer-reviewed Cannabis molecular-diagnostics study. Figure 19 explicitly states that symptomatic indoor/outdoor plants were subjected to molecular diagnostics and BCTV presence was confirmed by RT-PCR.",
      "limitations": "BCTV symptoms vary by genotype and are not visually specific. Use only as a laboratory-confirmed Cannabis virus reference; do not identify BCTV from leaf curl, stunting, discoloration, or growth pattern alone. Keep training-ineligible as a full composite.",
      "diagnostic_label": null,
      "host_species": null,
      "host_context": null,
      "view": null,
      "stage": null,
      "severity": null,
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "25decd9424d09359794823ac2357bb6b13e99d9f34247f4f1acfca6016343e90",
      "perceptual_hash": "dhash64:1c9892b2985a7ab3",
      "bytes": 4044362,
      "mime_type": "image/png",
      "width": 2686,
      "height": 1811,
      "image_format": "PNG",
      "origin_registry": "dataset/acquisition/verified-open-media-candidates.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "media-cannabis-aphid-figure-2",
      "issue_slug": "cannabis-aphid",
      "repository_path": "images/reference/original/media-cannabis-aphid-figure-2.png",
      "source_image_url": "https://mdpi-res.com/d_attachment/plants/plants-14-00931/article_deploy/html/images/plants-14-00931-g002.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/plants/plants-14-00931/article_deploy/html/images/plants-14-00931-g002.png",
      "source_article": "https://doi.org/10.3390/plants14060931",
      "caption": "Cannabis plants of the Congo Durban variety infested with Phorodon cannabis, plus adult and winged adult aphids under a stereo microscope at 20× magnification (Figure 2).",
      "creator": "Daniel Lopez Restrepo and Igor Kovalchuk",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": null,
      "confirmation": "Peer-reviewed open-access Cannabis aphid study established colonies on Cannabis sativa and used morphology under 20× stereo microscopy to distinguish Phorodon cannabis from similar aphids.",
      "limitations": "Multi-panel plant-and-organism figure. Use as Cannabis host and aphid morphology reference; do not infer that yellowing or wilting alone identifies cannabis aphid. Keep training-ineligible until panel-level source grouping and crop review are complete.",
      "diagnostic_label": null,
      "host_species": null,
      "host_context": null,
      "view": null,
      "stage": null,
      "severity": null,
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "8b207dc0bc39fbfb7efd8e0356f2a4edeccdcf4028980d1544fc71e753c529d9",
      "perceptual_hash": "dhash64:6444daa9ad9b989a",
      "bytes": 1980683,
      "mime_type": "image/png",
      "width": 1623,
      "height": 1724,
      "image_format": "PNG",
      "origin_registry": "dataset/acquisition/verified-open-media-candidates.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "media-fusarium-cannabis-figure-4",
      "issue_slug": "fusarium-crown-root-rot",
      "repository_path": "images/reference/original/media-fusarium-cannabis-figure-4.webp",
      "source_image_url": "https://www.frontiersin.org/files/Articles/796062/xml-images/fagro-03-796062-g0004.webp",
      "resolved_image_url": "https://www.frontiersin.org/files/Articles/796062/xml-images/fagro-03-796062-g0004.webp",
      "source_article": "https://doi.org/10.3389/fagro.2021.796062",
      "caption": "Infection of greenhouse grown cannabis plants by Fusarium species (Figure 4), including yellowing, crown infection/decay, pith necrosis, crown rot, diseased cuttings, flower infection, cultures, and pathogenicity-test symptoms.",
      "creator": "Zamir Punja (photographs), published in Gwinn et al. 2022",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": null,
      "confirmation": "Peer-reviewed Cannabis Fusarium composite tied to published organism identification and pathogenicity evidence in the source review and cited primary studies.",
      "limitations": "Multi-panel, multi-species disease composite. Use only as a reviewed reference figure; the full composite is not a single-class training image and cannot visually confirm a Fusarium species in an unknown user plant.",
      "diagnostic_label": null,
      "host_species": null,
      "host_context": null,
      "view": null,
      "stage": null,
      "severity": null,
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "a02abbebd496081013d34deb188640f3fc134a1ce3b0a77526ddd2babb576ebf",
      "perceptual_hash": "dhash64:a7cd13d159c9cfcd",
      "bytes": 2589208,
      "mime_type": "image/webp",
      "width": 1417,
      "height": 1748,
      "image_format": "WEBP",
      "origin_registry": "dataset/acquisition/verified-open-media-candidates.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "media-fusarium-flower-bud-figure-1",
      "issue_slug": "fusarium-foliar-flower-head-blight",
      "repository_path": "images/reference/original/media-fusarium-flower-bud-figure-1.png",
      "source_image_url": "https://mdpi-res.com/d_attachment/jof/jof-11-00528/article_deploy/html/images/jof-11-00528-g001.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/jof/jof-11-00528/article_deploy/html/images/jof-11-00528-g001.png",
      "source_article": "https://doi.org/10.3390/jof11070528",
      "caption": "Natural Fusarium-associated infection of Cannabis inflorescences: pinkish-white growth on intact greenhouse flowers and external or internal growth on dried flowers from the same licensed facility (Punja et al. 2025, Figure 1). Fusarium was confirmed by plant-linked isolation and molecular identification.",
      "creator": "Zamir K. Punja, Sheryl A. Tittlemier, and Sean Walkowiak",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": "Punja ZK, Tittlemier SA, Walkowiak S. 2025. Fusarium Species Infecting Greenhouse-Grown Cannabis (Cannabis sativa) Plants Show Potential for Mycotoxin Production in Inoculated Inflorescences and from Natural Inoculum Sources. Journal of Fungi 11(7):528. Figure 1. CC BY 4.0.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "Four-panel composite combining intact greenhouse inflorescences and dried postharvest flowers; reference-only as a whole figure.",
        "The source recovered both Fusarium avenaceum and F. graminearum from Cannabis tissues but does not provide a panel-by-panel species label, so the image cannot train or confirm either species class.",
        "Pinkish-white surface or internal growth overlaps other flower molds and remains insufficient without plant-linked culture and suitable molecular identification.",
        "Do not crop panels into independent examples or infer field progression, prevalence, mycotoxin identity, or mycotoxin concentration from this composite."
      ],
      "diagnostic_label": "fusarium-foliar-flower-head-blight — naturally infected intact and dried Cannabis inflorescence composite reference",
      "host_species": "Cannabis sativa",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "flower through postharvest drying",
      "severity": "visible surface and internal colonization",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "08ab22210fa1a1242a570520352641a4954f0e3ab213f23e3fbb5ddae2e0a6ce",
      "perceptual_hash": "dhash64:64cccec5e9c8cccc",
      "bytes": 6450082,
      "mime_type": "image/png",
      "width": 2058,
      "height": 3069,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "media-hlvd-cannabis-figure-1",
      "issue_slug": "hop-latent-viroid",
      "repository_path": "images/reference/original/media-hlvd-cannabis-figure-1.png",
      "source_image_url": "https://mdpi-res.com/d_attachment/plants/plants-14-00830/article_deploy/html/images/plants-14-00830-g001.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/plants/plants-14-00830/article_deploy/html/images/plants-14-00830-g001.png",
      "source_article": "https://doi.org/10.3390/plants14050830",
      "caption": "Cannabis stock plants and HLVd detection results from leaf and root tissues (Figure 1), with HLVd bands confirmed by sequence analysis; the study describes infected plants as showing reduced vigor, smaller leaves, stunting, and reduced inflorescence development.",
      "creator": "Zamir K. Punja, Cameron Scott, Heather H. Tso, Jack Munz, and Liam Buirs; figure photographer not separately stated",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": null,
      "confirmation": "Peer-reviewed 2025 Cannabis HLVd study using RT-PCR/RT-qPCR and sequence confirmation. Figure 1 ties sampled Cannabis plants to molecular HLVd detection rather than visual diagnosis alone.",
      "limitations": "HLVd is laboratory-bounded. Use only as a molecularly anchored Cannabis disease reference. Do not visually confirm HLVd from stunting, yellowing, small leaves, weak roots, or reduced flowering. Keep training-ineligible as a full composite.",
      "diagnostic_label": null,
      "host_species": null,
      "host_context": null,
      "view": null,
      "stage": null,
      "severity": null,
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "843e7d7421152fb9cc8a0b35c62610a2a5933367dbe2105ea2edacb2119f90d8",
      "perceptual_hash": "dhash64:9e3ab2dad2b8ba9c",
      "bytes": 5264806,
      "mime_type": "image/png",
      "width": 2262,
      "height": 2713,
      "image_format": "PNG",
      "origin_registry": "dataset/acquisition/verified-open-media-candidates.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "media-powdery-mildew-cannabis-figure-2",
      "issue_slug": "powdery-mildew",
      "repository_path": "images/reference/original/media-powdery-mildew-cannabis-figure-2.webp",
      "source_image_url": "https://www.frontiersin.org/files/Articles/720215/xml-images/fagro-03-720215-g0002.webp",
      "resolved_image_url": "https://www.frontiersin.org/files/Articles/720215/xml-images/fagro-03-720215-g0002.webp",
      "source_article": "https://doi.org/10.3389/fagro.2021.720215",
      "caption": "Cannabis powdery mildew resistance experiment showing a susceptible phenotype with dense mycelial growth beside a resistant phenotype without visible powdery mildew colonies (Figure 2).",
      "creator": "Paul D. Mihalyov and Andrea R. Garfinkel",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": null,
      "confirmation": "Peer-reviewed Cannabis powdery mildew study; the source also characterized Golovinomyces ambrosiae conidia and conidiophores from infected Cannabis leaves and used controlled inoculation/phenotyping.",
      "limitations": "Reference figure includes susceptible and resistant phenotypes under imposed disease pressure. Visible white mycelium supports powdery-mildew suspicion but does not replace organism/pathology confirmation when the causal species matters.",
      "diagnostic_label": null,
      "host_species": null,
      "host_context": null,
      "view": null,
      "stage": null,
      "severity": null,
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "7690fd41440735591b9e4562b00fdc58274577cbb3ea38f305f98c27474e6046",
      "perceptual_hash": "dhash64:69accecc8edb638e",
      "bytes": 887598,
      "mime_type": "image/webp",
      "width": 1535,
      "height": 1027,
      "image_format": "WEBP",
      "origin_registry": "dataset/acquisition/verified-open-media-candidates.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "media-pythium-hemp-pathogenicity-figure-7",
      "issue_slug": "pythium-root-rot",
      "repository_path": "images/reference/original/media-pythium-hemp-pathogenicity-figure-7.webp",
      "source_image_url": "https://www.frontiersin.org/files/Articles/706138/xml-images/fagro-03-706138-g0007.webp",
      "resolved_image_url": "https://www.frontiersin.org/files/Articles/706138/xml-images/fagro-03-706138-g0007.webp",
      "source_article": "https://doi.org/10.3389/fagro.2021.706138",
      "caption": "Hemp 'Wife' plants 14 days after inoculation with pathogenic Pythium myriotylum, Globisporangium irregulare, or Fusarium oxysporum isolates, plus the uninoculated control (Figure 7).",
      "creator": "Cora S. McGehee and Rosa E. Raudales",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": null,
      "confirmation": "Controlled pathogenicity study on hemp used identified isolates, inoculation, symptom tracking, and re-isolation; Pythium myriotylum produced strong growth reduction, chlorosis, and wilt in vivo.",
      "limitations": "Multi-pathogen treatment composite. Use as controlled pathogenicity/context reference only; the whole-plant appearance is not Pythium-specific and cannot visually confirm the causal organism in an unknown plant.",
      "diagnostic_label": null,
      "host_species": null,
      "host_context": null,
      "view": null,
      "stage": null,
      "severity": null,
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "54267dc0fe3eccabaa8f5bd87cae3394beece60a21134bac7d765c0d1817d47b",
      "perceptual_hash": "dhash64:e949555123865373",
      "bytes": 1682230,
      "mime_type": "image/webp",
      "width": 2008,
      "height": 1501,
      "image_format": "WEBP",
      "origin_registry": "dataset/acquisition/verified-open-media-candidates.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "media-rice-root-aphid-cannabis-figure-2",
      "issue_slug": "rice-root-aphid",
      "repository_path": "images/reference/original/media-rice-root-aphid-cannabis-figure-2.jpeg",
      "source_image_url": "https://oup.silverchair-cdn.com/oup/backfile/Content_public/Journal/jipm/11/1/10.1093_jipm_pmaa008/2/m_pmaa008f0002.jpeg?Expires=2147483647&Key-Pair-Id=APKAIE5G5CRDK6RD3PGA&Signature=EPhu~pO~64p7GWKwLaeesO7JYfmMa8VpG5vqYu3ZxcGNwF4RdNFDEDOKBStsTpzEbph7z24JZxLSMtGslR7jMlrIlILt1UcCGx-Fnyt19QbE7xHClKmKI~qCVKVkjbXTWnBnVEtu9oUVGZdiWWD4SAO9ncgBncMgG1~Qh3cKeT6LT65KkdLoqRRDtwc0UU6riQgTj77ZsnuPdaXALAY5kAPxOwv1fVEZjnWJEcrAw3qygYI3bvDiIg0vF1UfSWUkiufo5KMGNkW1chR9j4IMsHkkoB6tE9ypcaSyRmoYdX5sKbjjeJmarUMy5LQJZGUSSqEQeOD7781Q5oWjw8UsXA__",
      "resolved_image_url": "https://oup.silverchair-cdn.com/oup/backfile/Content_public/Journal/jipm/11/1/10.1093_jipm_pmaa008/2/m_pmaa008f0002.jpeg?Expires=2147483647&Key-Pair-Id=APKAIE5G5CRDK6RD3PGA&Signature=EPhu~pO~64p7GWKwLaeesO7JYfmMa8VpG5vqYu3ZxcGNwF4RdNFDEDOKBStsTpzEbph7z24JZxLSMtGslR7jMlrIlILt1UcCGx-Fnyt19QbE7xHClKmKI~qCVKVkjbXTWnBnVEtu9oUVGZdiWWD4SAO9ncgBncMgG1~Qh3cKeT6LT65KkdLoqRRDtwc0UU6riQgTj77ZsnuPdaXALAY5kAPxOwv1fVEZjnWJEcrAw3qygYI3bvDiIg0vF1UfSWUkiufo5KMGNkW1chR9j4IMsHkkoB6tE9ypcaSyRmoYdX5sKbjjeJmarUMy5LQJZGUSSqEQeOD7781Q5oWjw8UsXA__",
      "source_article": "https://doi.org/10.1093/jipm/pmaa008",
      "caption": "Rice root aphids living on the roots of aeroponically grown Cannabis sativa (Figure 2).",
      "creator": "Whitney Cranshaw and Suzanne Wainwright-Evans; figure photographer not separately stated in the caption",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": null,
      "confirmation": "Published Cannabis host figure in a peer-reviewed open-access article identifying Rhopalosiphum rufiabdominale on Cannabis roots.",
      "limitations": "Use as organism/root-zone reference evidence. Do not infer that generalized canopy decline uniquely identifies rice root aphid. Do not mark training-eligible until source-group and panel-level review are complete.",
      "diagnostic_label": null,
      "host_species": null,
      "host_context": null,
      "view": null,
      "stage": null,
      "severity": null,
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "3fb068bfe723ed06c654bfcc96f990bfabdfa2e976a7770242325c7ae311dea4",
      "perceptual_hash": "dhash64:19191b1a4e595b6b",
      "bytes": 38338,
      "mime_type": "image/jpeg",
      "width": 520,
      "height": 403,
      "image_format": "JPEG",
      "origin_registry": "dataset/acquisition/verified-open-media-candidates.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "media-thrips-hemp-bugwood-5569060",
      "issue_slug": "thrips",
      "repository_path": "images/reference/original/media-thrips-hemp-bugwood-5569060.jpg",
      "source_image_url": "https://bugwoodcloud.org/images/1536x1024/5569060.jpg",
      "resolved_image_url": "https://bugwoodcloud.org/images/1536x1024/5569060.jpg",
      "source_article": "https://www.invasive.org/browse/detail.cfm?imgnum=5569060",
      "caption": "Severe leaf injury to hemp produced by onion thrips (Thrips tabaci), Bugwood image 5569060.",
      "creator": "Whitney Cranshaw, Colorado State University, Bugwood.org",
      "license": "CC BY 3.0",
      "license_url": "https://creativecommons.org/licenses/by/3.0/",
      "required_attribution": null,
      "confirmation": "Bugwood/Invasive.org record 5569060 identifies the subject as Thrips tabaci, descriptor Damage, host Cannabis sativa L., with severe leaf injury to hemp and CC BY 3.0 reuse terms.",
      "limitations": "Use as a Cannabis/hemp feeding-damage reference, not as species-level confirmation. Silvery or pale feeding scars can overlap other pests and injury; confirm thrips adults or larvae with magnification when identifying the causal insect.",
      "diagnostic_label": null,
      "host_species": null,
      "host_context": null,
      "view": null,
      "stage": null,
      "severity": null,
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "04234384d5ab682600c748a65a62395adbf1cdfbe1f9489df43969025d53e54c",
      "perceptual_hash": "dhash64:b3e78e80888094ca",
      "bytes": 916334,
      "mime_type": "image/jpeg",
      "width": 1536,
      "height": 1152,
      "image_format": "JPEG",
      "origin_registry": "dataset/acquisition/verified-open-media-candidates-batch3.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "previously-persisted-remote-temporarily-unavailable"
    },
    {
      "id": "media-two-spotted-spider-mite-hemp-figure-1",
      "issue_slug": "two-spotted-spider-mites",
      "repository_path": "images/reference/original/media-two-spotted-spider-mite-hemp-figure-1.png",
      "source_image_url": "https://mdpi-res.com/d_attachment/agronomy/agronomy-16-00651/article_deploy/html/images/agronomy-16-00651-g001.png",
      "resolved_image_url": "https://mdpi-res.com/d_attachment/agronomy/agronomy-16-00651/article_deploy/html/images/agronomy-16-00651-g001.png",
      "source_article": "https://doi.org/10.3390/agronomy16060651",
      "caption": "Standardized 0–5 visual damage scale for two-spotted spider mite (Tetranychus urticae) on flowering hemp, from no visible damage through stippling/chlorosis to extensive necrosis and dense webbing (Figure 1).",
      "creator": "Ivy N. Thweatt and Katelyn Kesheimer; figure included in the article with consent",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": null,
      "confirmation": "Peer-reviewed 2026 hemp study assessed Tetranychus urticae herbivory with a standardized damage scale under greenhouse exposure. The article identifies spider mite feeding injury as foliar stippling, chlorosis, necrosis, and webbing.",
      "limitations": "Damage-scale composite rather than a clean single-class training photo. Confirm mites or eggs on leaf undersides with magnification before attributing stippling/webbing to Tetranychus urticae. Keep the full figure training-ineligible until panel-level review and source grouping are complete.",
      "diagnostic_label": null,
      "host_species": null,
      "host_context": null,
      "view": null,
      "stage": null,
      "severity": null,
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "373860a3230e75afaebd94fbc0ed95fe8e3620fc812b1b659b321597010182ef",
      "perceptual_hash": "dhash64:d2129296869696b6",
      "bytes": 1893778,
      "mime_type": "image/png",
      "width": 1455,
      "height": 1340,
      "image_format": "PNG",
      "origin_registry": "dataset/acquisition/verified-open-media-candidates.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "ncsu-hrm-canopy-damage-5574606",
      "issue_slug": "hemp-russet-mite",
      "repository_path": "images/reference/original/ncsu-hrm-canopy-damage-5574606.jpeg",
      "source_image_url": "https://content.ces.ncsu.edu/media/images/5574606-WEB.jpeg",
      "resolved_image_url": "https://content.ces.ncsu.edu/media/images/5574606-WEB.jpeg",
      "source_article": "https://content.ces.ncsu.edu/print_image/12579",
      "caption": "Canopy-level hemp russet mite damage showing yellowing and stunting; microscopy is still required because this appearance overlaps abiotic and disease injury.",
      "creator": "Whitney Cranshaw, Colorado State University, Bugwood.org",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": "Whitney Cranshaw, Colorado State University, Bugwood.org; CC BY 4.0",
      "confirmation": "expert-reviewed",
      "limitations": [
        "Canopy injury is nonspecific and requires microscope confirmation.",
        "Excluded from training until a separate training and dataset-split review is complete."
      ],
      "diagnostic_label": "hemp-russet-mite-whole-plant-damage",
      "host_species": "Cannabis sativa",
      "host_context": "cannabis",
      "view": "whole-plant",
      "stage": "pre-harvest or harvest",
      "severity": "symptomatic",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "3bb67e69f4bf90404b4581c62d806f6523f663fbd0ab6ca8cce5abb99d4fe6f6",
      "perceptual_hash": "dhash64:1f5d9b4b63b32b3f",
      "bytes": 27723,
      "mime_type": "image/jpeg",
      "width": 384,
      "height": 288,
      "image_format": "JPEG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "ncsu-hrm-life-stages-5574608",
      "issue_slug": "hemp-russet-mite",
      "repository_path": "images/reference/original/ncsu-hrm-life-stages-5574608.jpeg",
      "source_image_url": "https://content.ces.ncsu.edu/media/images/5574608-WEB.jpeg",
      "resolved_image_url": "https://content.ces.ncsu.edu/media/images/5574608-WEB.jpeg",
      "source_article": "https://content.ces.ncsu.edu/print_image/12580",
      "caption": "Multiple life stages of hemp russet mite on hemp leaf tissue; use as a morphology reference, not as proof from an ordinary plant photograph.",
      "creator": "Whitney Cranshaw, Colorado State University, Bugwood.org",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": "Whitney Cranshaw, Colorado State University, Bugwood.org; CC BY 4.0",
      "confirmation": "expert-reviewed",
      "limitations": [
        "Microscope morphology reference only; an ordinary plant image cannot resolve this mite.",
        "Excluded from training until a separate training and dataset-split review is complete."
      ],
      "diagnostic_label": "hemp-russet-mite-microscope-life-stages",
      "host_species": "Cannabis sativa",
      "host_context": "cannabis",
      "view": "microscope",
      "stage": "multiple mite life stages",
      "severity": "confirmed presence",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "2b663263afccc22aa652e5968e0f7f3932f1b6fb0077fb42784ccd811b1b2d35",
      "perceptual_hash": "dhash64:8903400adcf97e0e",
      "bytes": 20338,
      "mime_type": "image/jpeg",
      "width": 384,
      "height": 257,
      "image_format": "JPEG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "plant-direct-cannabis-southern-blight-figure-2",
      "issue_slug": "southern-blight-athelia-rolfsii",
      "repository_path": "images/reference/original/plant-direct-cannabis-southern-blight-figure-2.jpg",
      "source_image_url": "https://cdn.ncbi.nlm.nih.gov/pmc/blobs/1415/10485662/00015b09cfc4/PLD3-7-e528-g008.jpg",
      "resolved_image_url": "https://cdn.ncbi.nlm.nih.gov/pmc/blobs/1415/10485662/00015b09cfc4/PLD3-7-e528-g008.jpg",
      "source_article": "https://doi.org/10.1002/pld3.528",
      "caption": "CC BY 4.0 controlled-study Figure 2 showing Cannabis morphology across days 0, 6, 8, and 13. It combines four treatment groups and not-to-scale insets; chitosan changes root growth, so the composite is reference context rather than panel-level southern-blight training ground truth.",
      "creator": "Pipob Suwanchaikasem, Shuai Nie, Jamie Selby-Pham, Robert Walker, Berin A. Boughton, and Alexander Idnurm",
      "license": "CC BY 4.0",
      "license_url": "https://creativecommons.org/licenses/by/4.0/",
      "required_attribution": "Suwanchaikasem et al. (2023), Plant Direct, Figure 2, https://doi.org/10.1002/pld3.528, licensed CC BY 4.0.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "The source figure is a 4-by-4 multi-treatment, multi-timepoint composite rather than a single positive diagnostic image.",
        "Control, chitosan-only, Athelia rolfsii, and chitosan-plus-pathogen groups must not be collapsed into one class.",
        "Chitosan independently inhibited root development, and right-side shoot and root insets are explicitly not to scale.",
        "The hydroponic Ferimon experiment ended five days after crown inoculation and did not show visible root browning or root rot; it does not represent field progression or every cultivar.",
        "Display with the full caption and attribution; do not crop, relabel, or use for automated training until panel identities, timepoints, treatment confounding, and sample linkage are resolved."
      ],
      "diagnostic_label": "southern-blight-athelia-rolfsii — laboratory-confirmed four-treatment, four-timepoint Cannabis composite reference only",
      "host_species": "Cannabis sativa",
      "host_context": "cannabis",
      "view": "whole-plant",
      "stage": "seedling; days 0–13 in Root-TRAPR",
      "severity": "control through five-day post-inoculation wilt",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "0f5b325ee5dd83bc8a5678efa4c1cc4d5bd7aaad2b2650bfbec3df092f639c7f",
      "perceptual_hash": "dhash64:cac3d2cae2e6eaee",
      "bytes": 184797,
      "mime_type": "image/jpeg",
      "width": 744,
      "height": 608,
      "image_format": "JPEG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "new-or-byte-stable",
      "verification_status": "downloaded-image-validated-hashed-and-persisted"
    },
    {
      "id": "springer-cannabis-zinc-dose-response-figure-1",
      "issue_slug": "zinc-deficiency",
      "repository_path": "images/reference/original/springer-cannabis-zinc-dose-response-figure-1.png",
      "source_image_url": "https://media.springernature.com/full/springer-static/image/art%3A10.1186%2Fs42238-026-00404-0/MediaObjects/42238_2026_404_Fig1_HTML.png",
      "resolved_image_url": "https://media.springernature.com/lw685/springer-static/image/art%3A10.1186%2Fs42238-026-00404-0/MediaObjects/42238_2026_404_Fig1_HTML.png",
      "source_article": "https://doi.org/10.1186/s42238-026-00404-0",
      "caption": "Maturity-stage Annapurna dose response. Columns compare 0.05, 0.1, 0.35, 1, and 4 mg/L zinc; rows show whole plants, youngest fully developed leaves, roots, and apical inflorescences. Low-zinc leaf mottling may be phosphorus-mediated, while the highest-zinc column includes tip necrosis.",
      "creator": "Sivan Shiponi and Nirit Bernstein",
      "license": "CC BY 4.0",
      "required_attribution": "Shiponi S and Bernstein N (2026), Journal of Cannabis Research 8:33, Figure 1, CC BY 4.0; link the article and license and indicate modifications.",
      "confirmation": "lab-confirmed",
      "limitations": [
        "One clonal cultivar, perlite culture, Zn-EDTA, fixed nutrient recipe, and maturity-stage imaging do not establish universal symptoms, thresholds, or timing.",
        "The five columns are distinct zinc treatments and the rows are distinct organs or views; whole-image classification and random panel splitting are invalid.",
        "The 0.05 mg/L chlorosis may reflect phosphorus toxicity associated with low zinc, while the 4 mg/L column contains excess-zinc tip injury; both require separate labels and mechanistic uncertainty metadata.",
        "Reference display only until panels are bounded, dose-, organ-, and diagnosis-annotated, scientifically reviewed, and assigned a leakage-safe dataset split."
      ],
      "diagnostic_label": "zinc-deficiency-cannabis-dose-response-mixed-treatment-composite",
      "host_species": "Cannabis sativa Annapurna",
      "host_context": "cannabis",
      "view": "diagram",
      "stage": "flowering maturity after 71 treatment days",
      "severity": "five-level dose response",
      "intended_use": "reference-only",
      "trainingEligible": false,
      "sha256": "5dc048457dbfa3c5cccda950c0fb862eab3487cc5c7d2dce8b19daece04e5251",
      "perceptual_hash": "dhash64:9595b5d595b5f3f1",
      "bytes": 638686,
      "mime_type": "image/png",
      "width": 685,
      "height": 755,
      "image_format": "PNG",
      "origin_registry": "data/profile-reference-media.json",
      "drift_status": "official-publisher-alternate-render-visual-match",
      "verification_status": "publisher-fallback-validated-hashed-and-persisted",
      "expected_sha256": "77406f4c5846bec061534028e091b339334a30757aa5b1d134be197fcb2dd288",
      "expected_perceptual_hash": "dhash64:9595b5d595b5f3f1",
      "dhash_distance_from_curated": 0
    }
  ],
  "unavailable": [
    {
      "id": "mdpi-cannabis-s-mg-k-deficiency-figure-3",
      "issue_slug": "magnesium-deficiency",
      "source_image_url": "https://www.mdpi.com/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g003.png",
      "source_article": "https://doi.org/10.3390/app9204432",
      "license": "CC BY 4.0",
      "origin_registry": "data/profile-reference-media.json",
      "required_fetch": false,
      "reason": "HTTP 403: Forbidden",
      "http_status": 403,
      "previous_local_copy_preserved": true,
      "trainingEligible": false,
      "recovery": "fallbacks-failed",
      "recoveryAttempts": [
        {
          "url": "https://mdpi-res.com/d_attachment/applsci/applsci-09-04432/article_deploy/html/images/applsci-09-04432-g003.png",
          "result": "fingerprint-mismatch",
          "sha256": "1058c7888bc75c5942af1ae7c124c7514e56df45ea134c99fbb616320b108f44",
          "perceptualHash": "dhash64:908cb8edbdd2e9ad",
          "dhashDistance": 5
        }
      ]
    },
    {
      "id": "media-dectes-adult-bugwood-5205012-ccby3",
      "issue_slug": "dectes-stem-borer",
      "source_image_url": "https://bugwoodcloud.org/images/1536x1024/5205012.jpg",
      "source_article": "https://www.invasive.org/browse/image/5205012",
      "license": "CC BY 3.0",
      "origin_registry": "data/profile-reference-media.json",
      "required_fetch": false,
      "reason": "HTTP 403: Forbidden",
      "http_status": 403,
      "previous_local_copy_preserved": false,
      "trainingEligible": false,
      "recovery": "no-approved-publisher-fallback"
    },
    {
      "id": "media-thrips-hemp-bugwood-5569060",
      "issue_slug": "thrips",
      "source_image_url": "https://bugwoodcloud.org/images/1536x1024/5569060.jpg",
      "source_article": "https://www.invasive.org/browse/detail.cfm?imgnum=5569060",
      "license": "CC BY 3.0",
      "origin_registry": "dataset/acquisition/verified-open-media-candidates-batch3.json",
      "required_fetch": true,
      "reason": "HTTP 403: Forbidden",
      "http_status": 403,
      "previous_local_copy_preserved": true,
      "trainingEligible": false,
      "recovery": "no-approved-publisher-fallback"
    }
  ],
  "recoveredPublisherFallbackCount": 10,
  "recoveredPublisherFallbackIds": [
    "mdpi-cannabis-calcium-deficiency-figure-5",
    "mdpi-cannabis-iron-zinc-deficiency-figure-6",
    "mdpi-cannabis-magnesium-deficiency-figure-6",
    "mdpi-cannabis-mn-b-cu-deficiency-figure-4",
    "mdpi-cannabis-mn-b-toxicity-figure-5",
    "mdpi-cannabis-n-p-ca-deficiency-figure-2",
    "mdpi-cannabis-nitrogen-deficiency-figure-2-flowering",
    "mdpi-cannabis-potassium-deficiency-figure-4",
    "mdpi-cannabis-sulfur-deficiency-figure-7",
    "springer-cannabis-zinc-dose-response-figure-1"
  ]
}
